import { useEffect, useState } from "react";
import { navLinks, siteName } from "@/mocks/baoliao";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 border-b border-background-200/70" : "bg-transparent"
      }`}
    >
      {/* 顶部细条 */}
      <div className="hidden md:block border-b border-background-200/60">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-1.5">
          <p className="text-xs text-foreground-600 whitespace-nowrap">
            <span className="inline-flex w-2 h-2 rounded-full bg-primary-500 animate-pulse-dot mr-1.5" />
            今日更新 23 条线索 · 即时跟进中
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <a href="#about" className="hover:text-primary-600 transition-colors whitespace-nowrap">关于我们</a>
            <a href="#tip" className="hover:text-primary-600 transition-colors whitespace-nowrap">我要爆料</a>
            <a
              href="#tip"
              className="inline-flex items-center gap-1 rounded-md bg-primary-500 px-2.5 py-0.5 text-xs text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-flashlight-line" />
              投稿入口
            </a>
          </div>
        </div>
      </div>

      {/* 主导航 */}
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3 md:py-4">
        <a href="#top" className="flex items-center gap-2">
          <span className="inline-flex w-10 h-10 items-center justify-center rounded-lg bg-primary-600 text-background-50 text-lg">
            <i className="ri-quill-pen-fill" />
          </span>
          <span className="text-2xl md:text-3xl font-bold text-foreground-950 leading-none" style={{ fontFamily: "var(--font-heading)" }}>
            {siteName}
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.key}
              href={link.href}
              className="px-3 py-2 text-[15px] text-foreground-800 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#tip"
            className="hidden sm:inline-flex items-center gap-1.5 rounded-md bg-foreground-950 px-4 py-2 text-sm text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-megaphone-line" />
            我来爆料
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="inline-flex lg:hidden w-10 h-10 items-center justify-center rounded-md border border-background-300/70 text-foreground-900"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </nav>

      {/* 移动菜单 */}
      {open && (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50 px-4 md:px-6 pb-4 animate-rise-in">
          <div className="flex flex-col py-2">
            {navLinks.map((link) => (
              <a
                key={link.key}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-2.5 text-[15px] text-foreground-800 border-b border-background-200/50 whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#tip"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-600 px-4 py-2.5 text-sm text-background-50 whitespace-nowrap"
            >
              <i className="ri-megaphone-line" />
              我来爆料
            </a>
          </div>
        </div>
      )}
    </header>
  );
}